import request from '../utils/request'

const assetService = {
    // 获取门店列表
    getStoreList: (params) => {
        return request({
            url: '/store/getStoreByTenantId',
            method: 'post',
            data: params
        })
    },

    // 更新门店信息
    updateStoreInfo: (params) =>{
        return request({
            url: '/store/updateStoreInfo',
            method: 'post',
            data: params
        })
    },
    getStoreDocuments(params){
        return request({
            url: '/store/getDocuments',
            method: 'post',
            data: params
        })
    }
    ,

    // 获取门店投前评估数据
    getStoreEvaluate: (params) => {
        return request(
            {
                url: '/store/beforeInvestEvaluationReport',
                method: 'post',
                data: params,
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
    },
    
    // 获取公司基本信息
    getCompanyBasicInfo: (params) => {
        return request({
            url: '/store/beforeInvest/companyBasicInfo',
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    
    // 获取历史财务报表
    getIncomeStatement: (params) => {
        return request({
            url: '/store/beforeInvest/incomeStatement',
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    
    // 获取历史收入详情
    getHistoricalIncome: (params) => {
        return request({
            url: '/store/beforeInvest/historicalIncome',
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    
    // 获取PCF预估收入
    getPcfIncome: (params) => {
        return request({
            url: '/store/beforeInvest/pcfIncome',
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    
    // 获取预估净利润
    getEstimatedNetProfit: (params) => {
        return request({
            url: '/store/beforeInvest/estimatedNetProfit',
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },

    // 获取门店列表
    getStoreListByBrandCode: (params) => {
        return request({
            url: '/store/getStoreByBrandCode',
            method: 'post',
            data: params
        })
    }
    ,

    // 获取门店详情
    getStoreDetail: (storeEntCode) => {
        return request({
            url: `/store/getStoreDetail`,
            method: 'post',
            data: storeEntCode
        })
    },
    // 新建门店
    createStore: (params) => {
        return request({
            url: '/store/createStore',
            method: 'post',
            data: params
        })
    }
    ,
    // 批量新建门店
    batchCreateStores(params) {
        return request({
            url: '/store/batchCreateStores',
            method: 'post',
            data: params
        })
    }
    ,

    // 获取品牌列表
    getBrandList:(params) => {
        return request({
            url: `/brand/getBrandList`,
            method: 'post',
            data: params
        })
    }
    ,
    //获取品牌基础信息
    getBrandBaseInfo: (params) => {
        return request({
            url: '/brand/getBrandBaseInfo',
            method: 'post',
            data:  params
        })
    },
    // 新增品牌
    createBrand: (params) => {
        return request({
            url: '/brand/createBrand',
            method: 'post',
            data: params
        })
    }
    ,

    //获取企业工商信息
    getCompanyBaseInfo: (params) => {
        return request({
            url: '/company/getCompanyBaseInfo',
            method: 'post',
            data:  params
        })
    },

    //获取门店的联营协议
    getAgreementListByStoreEntCode: (params) => {
        return request({
            url: '/agreement/getAgreementListByStoreEntCode',
            method: 'post',
            data:  params
        })
    }
    ,
    getAgreementListByBrandCode: (params) => {
        return request({
            url: '/agreement/getAgreementListByBrandCode',
            method: 'post',
            data: params
        })
    },
    checkAgreementMissingInfo: (params) => {
        return request({
            url: '/agreement/checkMissingInfo',
            method: 'post',
            data: params
        })
    },
    createAgreement: (params) => {
        return request({
            url: '/agreement/create',
            method: 'post',
            data: params
        })
    },
    createBrandAgreement: (params) => {
        return request({
            url: '/agreement/createBrandLevel',
            method: 'post',
            data: params
        })
    },
    bindAgreementStores: (params) => {
        return request({
            url: '/agreement/bindStores',
            method: 'post',
            data: params
        })
    },
    updateStoreShareRatio: (params) => {
        return request({
            url: '/agreement/updateStoreShareRatio',
            method: 'post',
            data: params
        })
    },
    getBankMappingsByBrandCode: (params) => {
        return request({
            url: '/funds/mappings',
            method: 'get',
            params
        })
    },
    mapAccount: (params) => {
        return request({
            url: '/funds/mapAccount',
            method: 'post',
            data: params
        })
    },
    updateAccount: (params) => {
        return request({
            url: '/funds/updateAccount',
            method: 'post',
            data: params
        })
    },
    changeAccountStatus: (params) => {
        return request({
            url: '/funds/changeStatus',
            method: 'post',
            data: params
        })
    },
    // 获取历史收入信息
    getStoreIncome: (params) => {
        return request({
            url: '/store/getStoreIncome',
            method: 'post',
            data:  params
        })
    },
    checkStoreDocumentsComplete: (params) => {
        return request({
            url: '/store/checkDocumentsComplete',
            method: 'post',
            data: params
        })
    },

    // 获取出资信息表
    getJointOperationFunds: (params)=>{
        return request({
            url:'/funder/getFunder',
            method: 'post',
            data:  params
        })
    },
    createJointOperationFund: (params)=>{
        return request({
            url:'/funder/create',
            method: 'post',
            data:  params
        })
    },

    //获取收益分配方案表
    getJointOperationProfitDistribution: (params) => {
        return request({
            url:'/profit/getProfitByStoreEntCode',
            method: 'post',
            data:  params
        })
    }
    ,
    getProfitByAgreementNo: (params) => {
        return request({
            url:'/profit/getByAgreementNo',
            method: 'post',
            data: params
        })
    },
    createJointOperationProfitDistribution: (params) => {
        return request({
            url:'/profit/create',
            method: 'post',
            data:  params
        })
    }
    ,
    getBrandTurnoverTrend: (params) => {
        return request({
            url: '/brand/turnoverTrend',
            method: 'post',
            data: params
        })
    },

    // 上报门店营业额
    reportStoreIncome: (params) => {
        return request({
            url: '/store/reportIncome',
            method: 'post',
            data: params
        })
    },

    // 营业额预估
    forecastTurnover: (storeEntCode) => {
        return request({
            url: '/turnover-forecast/forecast',
            method: 'get',
            params: {
                storeEntCode: storeEntCode
            }
        })
    }
}

export default assetService